// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X_OL","content":"styles_content__FYztb","tableWrap":"styles_tableWrap__he7zX"};